import React, { Component } from 'react';
import moment from 'moment';
import 'moment/locale/ru';

import VideoPopup from './videoPopup';
import VideoIOS from './videoIOS';
import './replayListItem.css';

let isIOS = () => {
    let userAgent = window.navigator ? navigator.userAgent : false;
    if (userAgent)
        return /iPad|iPhone|iPod/.test(userAgent);
    return false;
};

export default class ReplayListItem extends Component {
    constructor(props){
        super(props);
        let self = this;
        this.state = {showPopup: false};
        this.open = () => {
            window.location.hash = 'fullscreen';
            this.setState({showPopup: true});

            window.onhashchange = function() {
                if (window.location.hash !== "#fullscreen") {
                    self.close();
                }
            }
        };
        this.close = () => {
            this.setState({showPopup: false})
            window.location.hash = '';
        };
    }

    render() {
        let r = this.props.replay;
        return (
            <div className="replay_item">
                {
                    isIOS() ?
                        <VideoIOS ytId={r.video}/>
                        :
                        <a className="replay_item__map"
                           style={{backgroundImage: `url(${r.map.image})`}}
                           onClick={this.open}
                        >
                            <i className="replay_item__youtube_icon"/>
                        </a>
                }


                <div className="replay_item__right_content">
                    <div className="replay_item__date">{moment(r.uploaded_at).format('DD MMMM, HH:mm')}</div>
                    {
                        isIOS() ?
                            <span className="replay_item__title replay_item__title-white">{r.title}</span>
                            :
                            <a className="replay_item__title" onClick={this.open}>{r.title}</a>
                    }

                    <div className="replay_item__result">
                        <span className="replay_item__result_elem"><i className="i-16_frags"/>{r.frags}</span>
                        <span className="replay_item__result_elem"><i className="i-16_exp"/>{r.exp}</span>
                        <span className="replay_item__result_elem"><i className="i-16_dmg"/>{r.dmg}</span>
                        <span className="replay_item__result_elem"><i className="i-16_cr"/>{r.creds}</span>
                    </div>

                    <div className="replay_item__info">Танк: {r.tank}</div>
                    <div className="replay_item__info">Карта: {r.map.title}</div>
                    <div className="replay_item__info">Играл: {r.player_username}</div>
                </div>

                <VideoPopup showPopup={this.state.showPopup} close={this.close} videoId={r.video}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ReplayListItem.js